'use client'

import React from 'react'

import { cn } from '../../utils/cn'
import { renderChildrenWithProps } from '../../utils/renderChildrenWithProps'
import { ButtonListItem, ButtonListItemProps } from './Item'

type ButtonListItemElement =
  | React.ReactElement<ButtonListItemProps>
  | null
  | undefined
  | boolean
  | ''

export interface ButtonListProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Content
   */
  children: ButtonListItemElement[]
}

type ButtonListComponent = ((props: ButtonListProps) => React.ReactNode) & {
  Item: typeof ButtonListItem
}

/**
 * ButtonList component
 */
export const ButtonList: ButtonListComponent = ({
  className,
  children,
}: ButtonListProps) => {
  return (
    <ol
      className={cn(
        'inline-flex items-center overflow-hidden rounded-full bg-white',
        'border border-solid border-blue-01',
        'shadow-[0px_4px_16px_rgba(0,0,0,0.1),0px_0px_0px_rgba(0,0,0,0.02)]',
        "[&>*]:after:h-[22px] [&>*]:after:w-px [&>*]:after:bg-blue-01 [&>*]:after:content-['']",
        '[&>*:last-child]:after:hidden',
        className,
      )}
    >
      {renderChildrenWithProps(children, {})}
    </ol>
  )
}

ButtonList.Item = ButtonListItem
